package org.junqueira.portfolio.ui.theme
import androidx.compose.ui.graphics.Color

val primaryLight = Color(0xFF39608F)
val onPrimaryLight = Color(0xFFFFFFFF)
val primaryContainerLight = Color(0xFFD3E4FF)
val onPrimaryContainerLight = Color(0xFF1E4876)
val secondaryLight = Color(0xFF545F70)
val onSecondaryLight = Color(0xFFFFFFFF)
val secondaryContainerLight = Color(0xFFD8E3F8)
val onSecondaryContainerLight = Color(0xFF3C4758)
val tertiaryLight = Color(0xFF6C5677)
val onTertiaryLight = Color(0xFFFFFFFF)
val tertiaryContainerLight = Color(0xFFF5D9FF)
val onTertiaryContainerLight = Color(0xFF543F5E)
val errorLight = Color(0xFFBA1A1A)
val onErrorLight = Color(0xFFFFFFFF)
val errorContainerLight = Color(0xFFFFDAD6)
val onErrorContainerLight = Color(0xFF93000A)
val backgroundLight = Color(0xFFF8F9FF)
val onBackgroundLight = Color(0xFF191C20)
val surfaceLight = Color(0xFFF8F9FF)
val onSurfaceLight = Color(0xFF191C20)
val surfaceVariantLight = Color(0xFFDFE2EB)
val onSurfaceVariantLight = Color(0xFF43474E)
val outlineLight = Color(0xFF73777F)
val outlineVariantLight = Color(0xFFC3C6CF)
val scrimLight = Color(0xFF000000)
val inverseSurfaceLight = Color(0xFF2E3035)
val inverseOnSurfaceLight = Color(0xFFEFF0F7)
val inversePrimaryLight = Color(0xFFA3C9FE)
val surfaceDimLight = Color(0xFFD8DAE0)
val surfaceBrightLight = Color(0xFFF8F9FF)
val surfaceContainerLowestLight = Color(0xFFFFFFFF)
val surfaceContainerLowLight = Color(0xFFF2F3FA)
val surfaceContainerLight = Color(0xFFECEDF4)
val surfaceContainerHighLight = Color(0xFFE7E8EE)
val surfaceContainerHighestLight = Color(0xFFE1E2E8)

val primaryLightMediumContrast = Color(0xFF043764)
val onPrimaryLightMediumContrast = Color(0xFFFFFFFF)
val primaryContainerLightMediumContrast = Color(0xFF496F9F)
val onPrimaryContainerLightMediumContrast = Color(0xFFFFFFFF)
val secondaryLightMediumContrast = Color(0xFF2C3747)
val onSecondaryLightMediumContrast = Color(0xFFFFFFFF)
val secondaryContainerLightMediumContrast = Color(0xFF626E80)
val onSecondaryContainerLightMediumContrast = Color(0xFFFFFFFF)
val tertiaryLightMediumContrast = Color(0xFF422F4D)
val onTertiaryLightMediumContrast = Color(0xFFFFFFFF)
val tertiaryContainerLightMediumContrast = Color(0xFF7C6586)
val onTertiaryContainerLightMediumContrast = Color(0xFFFFFFFF)
val errorLightMediumContrast = Color(0xFF740006)
val onErrorLightMediumContrast = Color(0xFFFFFFFF)
val errorContainerLightMediumContrast = Color(0xFFCF2C27)
val onErrorContainerLightMediumContrast = Color(0xFFFFFFFF)
val backgroundLightMediumContrast = Color(0xFFF8F9FF)
val onBackgroundLightMediumContrast = Color(0xFF191C20)
val surfaceLightMediumContrast = Color(0xFFF8F9FF)
val onSurfaceLightMediumContrast = Color(0xFF0F1116)
val surfaceVariantLightMediumContrast = Color(0xFFDFE2EB)
val onSurfaceVariantLightMediumContrast = Color(0xFF32363D)
val outlineLightMediumContrast = Color(0xFF4F535A)
val outlineVariantLightMediumContrast = Color(0xFF696D75)
val scrimLightMediumContrast = Color(0xFF000000)
val inverseSurfaceLightMediumContrast = Color(0xFF2E3035)
val inverseOnSurfaceLightMediumContrast = Color(0xFFEFF0F7)
val inversePrimaryLightMediumContrast = Color(0xFFA3C9FE)
val surfaceDimLightMediumContrast = Color(0xFFC5C6CC)
val surfaceBrightLightMediumContrast = Color(0xFFF8F9FF)
val surfaceContainerLowestLightMediumContrast = Color(0xFFFFFFFF)
val surfaceContainerLowLightMediumContrast = Color(0xFFF2F3FA)
val surfaceContainerLightMediumContrast = Color(0xFFE7E8EE)
val surfaceContainerHighLightMediumContrast = Color(0xFFDBDCE3)
val surfaceContainerHighestLightMediumContrast = Color(0xFFD0D1D8)

val primaryLightHighContrast = Color(0xFF002D54)
val onPrimaryLightHighContrast = Color(0xFFFFFFFF)
val primaryContainerLightHighContrast = Color(0xFF214B78)
val onPrimaryContainerLightHighContrast = Color(0xFFFFFFFF)
val secondaryLightHighContrast = Color(0xFF222D3C)
val onSecondaryLightHighContrast = Color(0xFFFFFFFF)
val secondaryContainerLightHighContrast = Color(0xFF3F4A5A)
val onSecondaryContainerLightHighContrast = Color(0xFFFFFFFF)
val tertiaryLightHighContrast = Color(0xFF382542)
val onTertiaryLightHighContrast = Color(0xFFFFFFFF)
val tertiaryContainerLightHighContrast = Color(0xFF564161)
val onTertiaryContainerLightHighContrast = Color(0xFFFFFFFF)
val errorLightHighContrast = Color(0xFF600004)
val onErrorLightHighContrast = Color(0xFFFFFFFF)
val errorContainerLightHighContrast = Color(0xFF98000A)
val onErrorContainerLightHighContrast = Color(0xFFFFFFFF)
val backgroundLightHighContrast = Color(0xFFF8F9FF)
val onBackgroundLightHighContrast = Color(0xFF191C20)
val surfaceLightHighContrast = Color(0xFFF8F9FF)
val onSurfaceLightHighContrast = Color(0xFF000000)
val surfaceVariantLightHighContrast = Color(0xFFDFE2EB)
val onSurfaceVariantLightHighContrast = Color(0xFF000000)
val outlineLightHighContrast = Color(0xFF282C33)
val outlineVariantLightHighContrast = Color(0xFF454951)
val scrimLightHighContrast = Color(0xFF000000)
val inverseSurfaceLightHighContrast = Color(0xFF2E3035)
val inverseOnSurfaceLightHighContrast = Color(0xFFFFFFFF)
val inversePrimaryLightHighContrast = Color(0xFFA3C9FE)
val surfaceDimLightHighContrast = Color(0xFFB7B8BF)
val surfaceBrightLightHighContrast = Color(0xFFF8F9FF)
val surfaceContainerLowestLightHighContrast = Color(0xFFFFFFFF)
val surfaceContainerLowLightHighContrast = Color(0xFFEFF0F7)
val surfaceContainerLightHighContrast = Color(0xFFE1E2E8)
val surfaceContainerHighLightHighContrast = Color(0xFFD3D4DA)
val surfaceContainerHighestLightHighContrast = Color(0xFFC5C6CC)

val primaryDark = Color(0xFFA3C9FE)
val onPrimaryDark = Color(0xFF00315C)
val primaryContainerDark = Color(0xFF1E4876)
val onPrimaryContainerDark = Color(0xFFD3E4FF)
val secondaryDark = Color(0xFFBCC7DB)
val onSecondaryDark = Color(0xFF263141)
val secondaryContainerDark = Color(0xFF3C4758)
val onSecondaryContainerDark = Color(0xFFD8E3F8)
val tertiaryDark = Color(0xFFD8BDE3)
val onTertiaryDark = Color(0xFF3C2947)
val tertiaryContainerDark = Color(0xFF543F5E)
val onTertiaryContainerDark = Color(0xFFF5D9FF)
val errorDark = Color(0xFFFFB4AB)
val onErrorDark = Color(0xFF690005)
val errorContainerDark = Color(0xFF93000A)
val onErrorContainerDark = Color(0xFFFFDAD6)
val backgroundDark = Color(0xFF111418)
val onBackgroundDark = Color(0xFFE1E2E8)
val surfaceDark = Color(0xFF111418)
val onSurfaceDark = Color(0xFFE1E2E8)
val surfaceVariantDark = Color(0xFF43474E)
val onSurfaceVariantDark = Color(0xFFC3C6CF)
val outlineDark = Color(0xFF8D9199)
val outlineVariantDark = Color(0xFF43474E)
val scrimDark = Color(0xFF000000)
val inverseSurfaceDark = Color(0xFFE1E2E8)
val inverseOnSurfaceDark = Color(0xFF2E3035)
val inversePrimaryDark = Color(0xFF39608F)
val surfaceDimDark = Color(0xFF111418)
val surfaceBrightDark = Color(0xFF37393E)
val surfaceContainerLowestDark = Color(0xFF0C0E13)
val surfaceContainerLowDark = Color(0xFF191C20)
val surfaceContainerDark = Color(0xFF1D2024)
val surfaceContainerHighDark = Color(0xFF272A2F)
val surfaceContainerHighestDark = Color(0xFF32353A)

val primaryDarkMediumContrast = Color(0xFFC9DEFF)
val onPrimaryDarkMediumContrast = Color(0xFF002649)
val primaryContainerDarkMediumContrast = Color(0xFF6D93C5)
val onPrimaryContainerDarkMediumContrast = Color(0xFF000000)
val secondaryDarkMediumContrast = Color(0xFFD1DDF2)
val onSecondaryDarkMediumContrast = Color(0xFF1B2635)
val secondaryContainerDarkMediumContrast = Color(0xFF8691A4)
val onSecondaryContainerDarkMediumContrast = Color(0xFF000000)
val tertiaryDarkMediumContrast = Color(0xFFEFD3FA)
val onTertiaryDarkMediumContrast = Color(0xFF311E3B)
val tertiaryContainerDarkMediumContrast = Color(0xFFA188AB)
val onTertiaryContainerDarkMediumContrast = Color(0xFF000000)
val errorDarkMediumContrast = Color(0xFFFFD2CC)
val onErrorDarkMediumContrast = Color(0xFF540003)
val errorContainerDarkMediumContrast = Color(0xFFFF5449)
val onErrorContainerDarkMediumContrast = Color(0xFF000000)
val backgroundDarkMediumContrast = Color(0xFF111418)
val onBackgroundDarkMediumContrast = Color(0xFFE1E2E8)
val surfaceDarkMediumContrast = Color(0xFF111418)
val onSurfaceDarkMediumContrast = Color(0xFFFFFFFF)
val surfaceVariantDarkMediumContrast = Color(0xFF43474E)
val onSurfaceVariantDarkMediumContrast = Color(0xFFD9DCE5)
val outlineDarkMediumContrast = Color(0xFFAEB2BA)
val outlineVariantDarkMediumContrast = Color(0xFF8D9099)
val scrimDarkMediumContrast = Color(0xFF000000)
val inverseSurfaceDarkMediumContrast = Color(0xFFE1E2E8)
val inverseOnSurfaceDarkMediumContrast = Color(0xFF272A2F)
val inversePrimaryDarkMediumContrast = Color(0xFF204977)
val surfaceDimDarkMediumContrast = Color(0xFF111418)
val surfaceBrightDarkMediumContrast = Color(0xFF42444A)
val surfaceContainerLowestDarkMediumContrast = Color(0xFF05070B)
val surfaceContainerLowDarkMediumContrast = Color(0xFF1B1E22)
val surfaceContainerDarkMediumContrast = Color(0xFF25282D)
val surfaceContainerHighDarkMediumContrast = Color(0xFF303338)
val surfaceContainerHighestDarkMediumContrast = Color(0xFF3B3E43)

val primaryDarkHighContrast = Color(0xFFE9F0FF)
val onPrimaryDarkHighContrast = Color(0xFF000000)
val primaryContainerDarkHighContrast = Color(0xFF9FC5FA)
val onPrimaryContainerDarkHighContrast = Color(0xFF000C1D)
val secondaryDarkHighContrast = Color(0xFFE9F0FF)
val onSecondaryDarkHighContrast = Color(0xFF000000)
val secondaryContainerDarkHighContrast = Color(0xFFB8C3D7)
val onSecondaryContainerDarkHighContrast = Color(0xFF020C1A)
val tertiaryDarkHighContrast = Color(0xFFFCEAFF)
val onTertiaryDarkHighContrast = Color(0xFF000000)
val tertiaryContainerDarkHighContrast = Color(0xFFD4B9DF)
val onTertiaryContainerDarkHighContrast = Color(0xFF15041F)
val errorDarkHighContrast = Color(0xFFFFECE9)
val onErrorDarkHighContrast = Color(0xFF000000)
val errorContainerDarkHighContrast = Color(0xFFFFAEA4)
val onErrorContainerDarkHighContrast = Color(0xFF220001)
val backgroundDarkHighContrast = Color(0xFF111418)
val onBackgroundDarkHighContrast = Color(0xFFE1E2E8)
val surfaceDarkHighContrast = Color(0xFF111418)
val onSurfaceDarkHighContrast = Color(0xFFFFFFFF)
val surfaceVariantDarkHighContrast = Color(0xFF43474E)
val onSurfaceVariantDarkHighContrast = Color(0xFFFFFFFF)
val outlineDarkHighContrast = Color(0xFFEDF0F9)
val outlineVariantDarkHighContrast = Color(0xFFBFC2CB)
val scrimDarkHighContrast = Color(0xFF000000)
val inverseSurfaceDarkHighContrast = Color(0xFFE1E2E8)
val inverseOnSurfaceDarkHighContrast = Color(0xFF000000)
val inversePrimaryDarkHighContrast = Color(0xFF204977)
val surfaceDimDarkHighContrast = Color(0xFF111418)
val surfaceBrightDarkHighContrast = Color(0xFF4E5055)
val surfaceContainerLowestDarkHighContrast = Color(0xFF000000)
val surfaceContainerLowDarkHighContrast = Color(0xFF1D2024)
val surfaceContainerDarkHighContrast = Color(0xFF2E3035)
val surfaceContainerHighDarkHighContrast = Color(0xFF393B40)
val surfaceContainerHighestDarkHighContrast = Color(0xFF44474C)







